import React, { CSSProperties, memo } from 'react';

type IonIconProps = CSSProperties & {
  name: string;
  size?: number;
};

const IonIcon = ({ name, size = 24, ...rest }: IonIconProps) => (
  // @ts-ignore
  <ion-icon name={name} style={{ fontSize: size, ...rest }} />
);

export default memo(IonIcon);
